export default __webpack_public_path__ + "static/media/b1c7b525efdf9c54fa8d721736da0c29.svg";